import { render, staticRenderFns } from "./markReadyButton.vue?vue&type=template&id=2b6cc5ba"
import script from "./markReadyButton.vue?vue&type=script&lang=js"
export * from "./markReadyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports